export const colors: [string, string][] = [
    ["#124A74", ""],
		["#000000", "#0000007A"],
		["#31CF13", "#198E03"],
		["#8926B3", "#3B0060"],
		["#FF9812", "#B26500"],
		["#E01A4F", "#800022"],
		["#001AFF", "#000D81"],
]
